import { render, staticRenderFns } from "./vas-information.vue?vue&type=template&id=11458854&"
import script from "./vas-information.vue?vue&type=script&lang=js&"
export * from "./vas-information.vue?vue&type=script&lang=js&"
import style0 from "./vas-information.vue?vue&type=style&index=0&id=11458854&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports